export const getQueryParams = (formData) => {
  return Object.keys(formData)
      .map(key => `${key}=${encodeURIComponent(formData[key])}`)
      .join('&');
};